export default __webpack_public_path__ + "static/dollars-ce3eb8fc53b413ea962f0866f6e2f30e.jpg";